import React, {Component} from "react";
import {translate} from "react-i18nify";

import imgClose from "../../../resources/img/svgicons/cancel2.svg";

import Button from "./Button";

/**
 * @class CloseButton
 *
 * Predefined generic button with close label and SVG
 *
 * [Confluence page]{@link https://deso.atlassian.net/wiki/spaces/Redlike/pages/52068390/CloseButton}
 *
 * @param {function} [onClick] - called on click
 *
 * @example
 * <CloseButton onClick={this.handleCloseModalClick} />
 *
 */
export default class CloseButton extends Component {
    render() {
        return <Button onClick={this.props.onClick} label={translate("general.close")} svgBefore={imgClose} />;
    }
}
